import { useEffect, useState } from 'react';

export default function ScrollBuddy() {
  const [p, setP] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const on = () => {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      const s = window.scrollY;
      const prog = h > 0 ? Math.min(1, Math.max(0, s / h)) : 0;
      setP(prog);
      setVisible(s > 80);
    };
    on();
    window.addEventListener('scroll', on, { passive: true });
    window.addEventListener('resize', on);
    return () => { window.removeEventListener('scroll', on); window.removeEventListener('resize', on); };
  }, []);

  // Two full counterclockwise rotations across the page
  const rot = -720 * p;
  const top = `calc(${p * 90}vh + 4rem)`;

  return (
    <div
      aria-hidden="true"
      data-testid="scroll-buddy"
      className="hidden md:block fixed left-4 lg:left-6 z-40 pointer-events-none"
      style={{
        top,
        opacity: visible ? 1 : 0,
        transition: 'opacity 400ms ease',
      }}
    >
      <div style={{ transform: `rotate(${rot}deg)` }}>
        <svg width="42" height="42" viewBox="0 0 84 84" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <ellipse cx="15" cy="66" rx="11" ry="8" transform="rotate(22 15 66)" fill="#D9B98A" stroke="#3C096C" strokeWidth="1.5"/>
          <circle cx="10" cy="64" r="0.9" fill="#3C096C"/>
          <circle cx="14" cy="69" r="0.9" fill="#3C096C"/>
          <circle cx="42" cy="40" r="34" fill="#E0AAFF" stroke="#3C096C" strokeWidth="3.5"/>
          <path d="M8.5 46 L22 30 L29 37 L42 20 L50 30 L60 22 L75.5 43 A34 34 0 0 1 8.5 46 Z" fill="#9D4EDD"/>
          <path d="M8.5 46 L22 30 L29 37 L42 20 L50 30 L60 22 L75.5 43" fill="none" stroke="#3C096C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="32" cy="56" r="1.6" fill="#5A189A"/>
          <circle cx="46" cy="52" r="1.6" fill="#5A189A"/>
          <circle cx="57" cy="58" r="1.6" fill="#5A189A"/>
        </svg>
      </div>
      {/* rail */}
      <div className="absolute left-1/2 -translate-x-1/2 top-full mt-1 h-24 w-px bg-gradient-to-b from-orchid/60 to-transparent" />
    </div>
  );
}
